import React from "react";
import { Stack } from "@mui/material";
import Detail from "./detail";
import { useSelector } from "react-redux";

function Details() {
  const { currentHd } = useSelector((state: any) => state.pos);

  return (
    <Stack gap={1}>
      {currentHd?.details &&
        currentHd?.details?.length > 0 &&
        currentHd?.details.map((detail: any, index: number) => {
          return <Detail key={detail._id} stt={index + 1} data={detail} />;
        })}
    </Stack>
  );
}

export default Details;
